module.exports = __webpack_public_path__ + "img/remove.497b03db.png";